import React from 'react'
import { findFlamegraphNode, FlamegraphNode, TraceSpanCategory } from '../domain/Trace'
import Summary, { SummaryLine } from './summary'
import Router from '../router'
import { FrameSummary } from './flamegraph/FrameSummary'
import { summarizeFlamegraph } from './flamegraphToSummary'
import { LayerReport } from '../domain/TraceSummary'
import { TraceDetailsLayerReport } from './tracedetails/TraceDetailsLayerReport'
import { TraceDetails } from './tracedetails/TraceDetails'

interface Props {
    router: Router
    categories: { [category: string]: TraceSpanCategory }
    params?: { [name: string]: string }
    route: string
    flamegraph: FlamegraphNode
    layerReport: LayerReport
}

class FlamegraphBasedSummary extends React.Component<Props> {
    public static defaultProps = {
        route: 'XhprofProfilerBundle.Profile.summary',
    }

    public render() {
        const lines = summarizeFlamegraph(this.props.flamegraph)
        const selectedNodeId = this.props.params?.node || lines[0]?.id || null
        const selectedLine = selectedNodeId ? lines.find(line => line.id === selectedNodeId) : null
        const originalNodeForSelectedLine = selectedLine ? findFlamegraphNode(this.props.flamegraph, selectedLine.id) : null

        return (
            <Summary
                router={this.props.router}
                categories={this.props.categories}
                lines={lines}
                selectedLineId={selectedNodeId}
                defaultSort="wallTime"
                onLineClick={line => this.selectNode(line.id)}
                details={
                    selectedLine && originalNodeForSelectedLine ? (
                        <TraceDetails>
                            <FrameSummary
                                node={this.createArtificalNodeForSummaryLine(selectedLine, originalNodeForSelectedLine)}
                                traceTotals={this.props.flamegraph.values}
                                isAggregatedTrace={true}
                                sectionBelowTitle={
                                    selectedNodeId === lines[0].id ? (
                                        <TraceDetailsLayerReport
                                            layerReport={this.props.layerReport}
                                            wt={this.props.flamegraph.values.wt}
                                        />
                                    ) : null
                                }
                            />
                        </TraceDetails>
                    ) : null
                }
                isAggregated={true}
            />
        )
    }

    private createArtificalNodeForSummaryLine = (
        selectedLine: SummaryLine,
        originalNodeForSelectedLine: FlamegraphNode,
    ): FlamegraphNode => ({
        id: selectedLine.id,
        values: {
            wt: selectedLine.wallTime,
            mc: 0,
        },
        name: originalNodeForSelectedLine.name,
        children: [],
        title: originalNodeForSelectedLine.title,
        cat: originalNodeForSelectedLine.cat,
        customType: originalNodeForSelectedLine.customType,
        stats: {
            ct: selectedLine.callCount,
            wt: 0,
            mc: 0,
        },
        stack: originalNodeForSelectedLine.stack,
    })

    public selectNode(nodeId) {
        this.setQueryParameter({ node: nodeId })
    }

    public setQueryParameter(values) {
        const params = { ...this.props.params, ...values }
        this.props.router.replace(this.props.route, params)
    }
}

export default FlamegraphBasedSummary
